import { Component, Input } from '@angular/core';

export interface IBreadcrumbsItem {
  title: string;
  routerLink?: string | string[];
  queryParams?: object;
  href?: string;
}

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrl: './breadcrumbs.component.scss'
})
export class BreadcrumbsComponent {
  @Input() id = '';
  @Input() items: IBreadcrumbsItem[] = [];
  @Input() type: 'arrow' | '' = '';
  @Input() gutter: 'p0' | '' = '';
  @Input() newDesign = false;

  trackFn(index: number, item: IBreadcrumbsItem): number {
    return index;
  }
}
